import { LocalStorageKeys } from "@/shared/constants/local-storage-keys";

import { localStorageCheck } from "./local-storage-check";

export const setToLocalStorage = (name: LocalStorageKeys, value: string) => {
	if (localStorageCheck()) {
		window.localStorage.setItem(name, value);
	}
};
